var Alabama = "앨라배마";
var Alaska = "알래스카";
var Arizona = "애리조나";
var Arkansas = "아칸소";
var California = "북부";
var Colorado = "콜로라도";
var Connecticut = "코네티컷";
var Delaware = "델라웨어";
var Florida = "플로리다";
var Georgia = "조지아";
var Hawaii = "하와이";
var Idaho = "아이다호";
var Illinois = "일리노이";
var Indiana = "인디애나";
var Iowa = "아이오와";
var Kansas = "켄사스";
var Kentucky = "켄터키";
var Louisiana = "루이지애나";
var Maine = "메인";
var Maryland = "메릴랜드";
var Massachusetts = "매사추세츠";
var Michigan = "미시간";
var Minnesota = "미네소타";
var Mississippi = "미시시피";
var Missouri = "미주리";
var Montana = "몬태나";
var Nebraska = "네브래스카";
var Nevada = "네바다";
var Ohio = "오하이오";
var Oklahoma = "오클라호마";
var Oregon = "오레곤";
var Pennsylvania = "펜실베이니아";
var Tennessee = "테네시";
var Texas = "텍사스";
var Utah = "유타";
var Vermont = "버몬트";
var Virginia = "북부";
var Washington = "워싱턴";
var Wisconsin = "위스콘신";
var Wyoming = "와이오밍";
var USStates = {
	Alabama: Alabama,
	Alaska: Alaska,
	Arizona: Arizona,
	Arkansas: Arkansas,
	California: California,
	Colorado: Colorado,
	Connecticut: Connecticut,
	Delaware: Delaware,
	"District of Columbia (DC)": "컬럼비아 특별구(DC)",
	Florida: Florida,
	Georgia: Georgia,
	Hawaii: Hawaii,
	Idaho: Idaho,
	Illinois: Illinois,
	Indiana: Indiana,
	Iowa: Iowa,
	Kansas: Kansas,
	Kentucky: Kentucky,
	Louisiana: Louisiana,
	Maine: Maine,
	Maryland: Maryland,
	Massachusetts: Massachusetts,
	Michigan: Michigan,
	Minnesota: Minnesota,
	Mississippi: Mississippi,
	Missouri: Missouri,
	Montana: Montana,
	Nebraska: Nebraska,
	Nevada: Nevada,
	"New Hampshire": "뉴햄프셔",
	"New Jersey": "뉴저지",
	"New Mexico": "뉴멕시코",
	"New York": "뉴욕",
	"North Carolina": "노스캐롤라이나",
	"North Dakota": "노스다코타",
	Ohio: Ohio,
	Oklahoma: Oklahoma,
	Oregon: Oregon,
	Pennsylvania: Pennsylvania,
	"Rhode Island": "로드아일랜드",
	"South Carolina": "사우스캐롤라이나",
	"South Dakota": "사우스다코타",
	Tennessee: Tennessee,
	Texas: Texas,
	Utah: Utah,
	Vermont: Vermont,
	Virginia: Virginia,
	Washington: Washington,
	"West Virginia": "웨스트버지니아",
	Wisconsin: Wisconsin,
	Wyoming: Wyoming
};

export { Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana, Nebraska, Nevada, Ohio, Oklahoma, Oregon, Pennsylvania, Tennessee, Texas, Utah, Vermont, Virginia, Washington, Wisconsin, Wyoming, USStates as default };
